(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop();

	$(document).ready(function(){

		$('.testimonials-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  arrows: false,
		});

		$('.homepage-slider').slick({
		  dots: false,
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 1,
		  arrows: false,
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: true,
		});

	//This option is for pages with a slider of images
	var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });

		$('.image-gallery').slick({
		  arrows: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  centerMode: true,
		  variableWidth: true,
		  autoplay:true,
		  initialSlide: 1,
	});


		//This will create a lightbox gallery to replace the default wordpress gallery
		 var galleryItems = $('figure.wp-block-gallery figure.wp-block-image');

		  galleryItems.each(function() {
		  
		  var   caption = $(this).find( "figcaption" ),
		        captionText = $(caption).text(),
		        link = $(this).find( "a" ),
		        image = $(this).find( "img" );
		  $(image).attr('title', captionText);


		  });
		   // Galleries on Project Pages

		   if($('figure.wp-block-gallery').length > 0) {
		      var lightbox = new SimpleLightbox('figure.wp-block-gallery figure.wp-block-image a', {
		        // captionSelector : 'figcaption',
		        // captionType : 'text'
		      });
		    }
	});

	$(window).on('load',function() {

		//sizeBoxes('');
		

		// Animate loader off screen
	    $("#loader").fadeOut(300);
	});

	
	//scroll functions

	var scrollSections = $('.scroll-section');

	$.fn.isInViewport = function() {
	  var elementTop = $(this).offset().top;
	  var elementBottom = elementTop + $(this).outerHeight();

	  var viewportTop = $(window).scrollTop();
	  var viewportBottom = viewportTop + $(window).height();

	  //return elementBottom > viewportTop && elementTop < viewportBottom;
	  return viewportTop  >= (elementTop - 100) &&  viewportTop  <= elementTop + 100;
	};

	$(window).on('scroll',function() {
		scrollDistance = $(window).scrollTop();
		//console.log(scrollDistance);
		stickyHeaderClass(scrollDistance,200,siteHeader);

		scrollSections.each(function(index){


			 if ($(this).isInViewport()) {
				var thisID = $(this).attr('id');
				$('a').each(function(){
					$(this).removeClass('active-link');
					if($(this).attr('href') === '#'+thisID) {
						$(this).addClass('active-link');
					}
				});
			 }
		});
	});



		//sticky header function
	var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
		if(scrollDistanceMonitor > classDistance) {
			$(headerSelector).addClass('scrolled');
			// $('.top-title img').hide(function(){
			// 	$('.scroll-title img').show();
			// });	
		}
		else {
			$(headerSelector).removeClass('scrolled');
			// $('.scroll-title img').hide( function(){
			// 	$('.top-title img').show();
			// });
		}
	};

	var sizeBoxes = function(boxSelector){
		var boxSize = 0;

		$(boxSelector).each(function(index){
			var heightSet = $(this).innerHeight();
			if(heightSet > boxSize) {
				boxSize = heightSet;
			}
		});
		if($(window).width() > 767) {
			$(boxSelector).css('height', boxSize + 'px');
		}
		console.log(boxSize);
	};


//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});


$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $searchOverlayForm = $('.search-overlay-form'),
        $searchOverlay = $(".search-overlay"),
        $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$searchOverlayForm.is(e.target) // if the target of the click isn't the container...
    && $searchOverlayForm.has(e.target).length === 0 && !$menuSearchButton.is(e.target) && $targetBody.hasClass('search-open')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('search-open');
            event.stopPropagation();
    }
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 


//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });

        	$('#off-canvas').foundation('close', function(){

        });
    });
});

//this function os to animate numbers on the screen
if($('#counter-container').length > 0) {
	$(window).scroll(startCounter);

	function startCounter() {
	  let scrollY = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight - 150;
	  let divPos = document.querySelector('#counter-container').offsetTop;

	  if (scrollY > divPos) {
	    $(window).off("scroll", startCounter);

	    $('.count').each(function() {
	      var $this = $(this);
	      jQuery({
	        Counter: 0
	      }).animate({
	        Counter: $this.text().replace(/,/g, '')
	      }, {
	        duration: 2000,
	        easing: 'swing',
	        step: function() {
	          $this.text(commaSeparateNumber(Math.floor(this.Counter)));
	        },
	        complete: function() {
	          $this.text(commaSeparateNumber(this.Counter));
	          //alert('finished');
	        }
	      });
	    });

	    function commaSeparateNumber(num) {
	      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }
	}
}

//this function is connected to the publications download
$('.toggle-download-form').on('click',function(event){
	var formTarget = $(this).siblings('.download-form-wrapper');

	event.preventDefault();
	return false;
	$('.download-form-wrapper').fadeOut(300);
	formTarget.fadeToggle(300);
	$('body').toggleClass('download-form-is-open');
});
	
})( jQuery );